<template>
    <div class="button-sm button-sm-add" :disabled="disabled">
      <div :class="'button-sm__btn button-sm__btn-' + type" :disabled="disabled">
        <svg v-if="type === 'add'" width="12" height="12" viewBox="0 0 12 12" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M6 0L6 12" stroke="currentColor" stroke-width="2" />
            <path d="M12 6L2.68221e-07 6" stroke="currentColor" stroke-width="2" />
        </svg>
        <svg v-else-if="type === 'create'" width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.001 3.57129C12.001 3.38672 11.9229 3.20801 11.7823 3.07617L8.72263 0.205078C8.58199 0.0732422 8.39135 0 8.19134 0H8.00069V3.75H12.001V3.57129ZM17.8453 9.02344L14.8544 6.19922C14.5388 5.90332 13.9981 6.11133 13.9981 6.53027V8.4375H11.9979V10.3125H13.9981V12.2227C13.9981 12.6416 14.5388 12.8496 14.8544 12.5537L17.8453 9.72656C18.0516 9.5332 18.0516 9.2168 17.8453 9.02344ZM6.00052 9.84375V8.90625C6.00052 8.64844 6.22554 8.4375 6.50056 8.4375H12.001V4.6875H7.75067C7.33814 4.6875 7.00061 4.37109 7.00061 3.98438V0H0.750065C0.334404 0 0 0.313477 0 0.703125V14.2969C0 14.6865 0.334404 15 0.750065 15H11.251C11.6666 15 12.001 14.6865 12.001 14.2969V10.3125H6.50056C6.22554 10.3125 6.00052 10.1016 6.00052 9.84375Z" fill="currentColor"/>
        </svg>
      </div>
      <p class="button-sm__text button-sm-add__text" v-if="title">{{ title }}</p>
    </div>
</template>

<script>
export default {
  name: 'app-button-sm-add',
  props: {
    disabled: Boolean,
    title: String,
    type: {
      type: String,
      default: 'add'
    }
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>

.button-sm {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  cursor: pointer;
  user-select: none;

  &__btn {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px solid $color__copper-pink;
    border-radius: 100%;
    width: 20px;
    height: 20px;
    color: $color__copper-pink;
    transition: .3s;
    cursor: pointer;
    user-select: none;
    font-family: $font_main;
  }

  &__text {
    transition: .3s;
    margin-left: 10px;
  }

  // &__btn-add {
  //   background: $button_color_fourth;
  //   box-shadow: 0 2px 2px #527225;
  // }

  &__btn-create {
    background: $button_color;
    box-shadow: 0 2px 2px #C6523B;
  }

  &:hover {
    .button-sm__btn {
      border-color: $color__orange;
      color: $color__orange;
    }
  }

  // &:active {
  //   .button-sm-add__btn {
  //     box-shadow: inset 0 4px 4px #527225;
  //   }
  // }

  &[disabled] {
    color: $color_deactive;
    pointer-events: none;

    .button-sm__btn {
      background: $color_deactive;
      box-shadow: none;
    }
  }
}
</style>
